import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import { getShipmentMessage, shipmentsDictionary } from 'catalog/utils/shipments-dictionary'
import { SHIPMENTS_EXPRESS_MODALITIES } from 'catalog/utils/constants'

import * as S from './styled'

const ShipmentModality = ({ modality, deadline, cost }) => {
  const price = formatPriceToBRL(cost)

  const { label, deadlineMessage } = getShipmentMessage(modality, deadline)

  const isExpress = SHIPMENTS_EXPRESS_MODALITIES.includes(modality)

  return (
    <S.Modality key={modality} data-testid="shipment-modality">
      <Text noMargin>
        {label}{' '}
        {isExpress && (
          <S.ExpressTag as="strong" bold noMargin>
            expressa
          </S.ExpressTag>
        )}{' '}
        {deadlineMessage.prefix}{' '}
        <Text as="strong" bold noMargin>
          {deadlineMessage.main}
        </Text>
      </Text>
      <S.Price noMargin>{price}</S.Price>
    </S.Modality>
  )
}

export default ShipmentModality

ShipmentModality.propTypes = {
  modality: PropTypes.oneOf(Object.keys(shipmentsDictionary)).isRequired,
  cost: PropTypes.number.isRequired,
  deadline: PropTypes.number
}
